import { useRef } from 'react';

export default function useInput({ description, hasCustomError, customError, autoFocus } = {}) {
  const inputRef = useRef();

  const setInputRef = (ref) => {
    if (ref) {
      if (hasCustomError) {
        ref.setCustomValidity('Invalid');
      }
      else {
        ref.setCustomValidity('');
      }
      if (autoFocus) {
        ref.focus();
      }
      inputRef.current = ref;
    }
  };

  const isInputValid = () => {
    if (hasCustomError) {
      return false;
    }
    if (inputRef.current && inputRef.current.validity) {
      return inputRef.current.validity.valid !== false;
    }
    return true;
  };

  const getInputValidityMessage = () => {
    const validity = inputRef.current?.validity;
    const field = description || 'This field';
    if (!validity) {
      return '';
    }
    if (hasCustomError) {
      if (customError) {
        return customError;
      }
      else {
        return 'Invalid';
      }
    }
    if (validity.valueMissing) {
      return `${field} is required`;
    }
    if (validity.patternMismatch) {
      const validationType = inputRef.current.getAttribute('validation');
      if (validationType === 'email') {
        return 'Invalid email address';
      }
      else if (validationType === 'numer') {
        return 'Invalid number';
      }
      else if (validationType === 'date') {
        return 'Invalid date';
      }
      else {
        return 'Invalid input';
      }
    }
    if (validity.tooLong) {
      return 'Value is longer than maximum length';
    }
    if (validity.tooShort) {
      return 'Value is shorter than minimum length';
    }
    if (validity.rangeOverflow) {
      return 'Value is greater than maximum';
    }
    if (validity.rangeUnderflow) {
      return 'Value is less than minimum';
    }
    if (validity.typeMismatch) {
      return 'Invalid syntax';
    }
  };

  return { setInputRef, isInputValid, getInputValidityMessage }
}